import { FaAward } from "react-icons/fa";
import { TbDeviceMobileCog } from "react-icons/tb";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaTools } from "react-icons/fa";
import { faHandHoldingDollar } from '@fortawesome/free-solid-svg-icons';

const data = [
  { id: 1, icon: <TbDeviceMobileCog />, title: 'TEKNISI BERPENGALAMAN', desc: 'Ditangani langsung oleh teknisi berpengalaman untuk memastikan setiap perangkat mendapatkan penanganan terbaik.' },
  { id: 2, icon: <FontAwesomeIcon icon={faHandHoldingDollar} />, title: 'HARGA TERJANGKAU', desc: 'Kami menawarkan biaya servis yang kompetitif dengan kualitas pengerjaan yang tetap terjaga, transparan, dan didukung penanganan teknisi berpengalaman.' },
  { id: 3, icon: <FaAward />, title: 'GARANSI SERVICE', desc: 'Setiap layanan dilengkapi garansi hingga 24 bulan sebagai bentuk komitmen terhadap kualitas dan keamanan perangkat Anda.' },
  { id: 4, icon: <FaTools />, title: 'SUKU CADANG BERKUALITAS', desc: 'Ketersediaan suku cadang untuk berbagai kebutuhan perbaikan perangkat Apple dengan kualitas yang terjamin.' },
];

export default data;